/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './payment-community.reducer';

export const PaymentCommunityDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const paymentCommunityEntity = useAppSelector(state => state.paymentCommunity.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="paymentCommunityDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.paymentCommunity.detail.title">PaymentCommunity</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.paymentCommunity.id">Id</Translate>
            </span>
          </dt>
          <dd>{paymentCommunityEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.paymentCommunity.name">Name</Translate>
            </span>
          </dt>
          <dd>{paymentCommunityEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.paymentCommunity.description">Description</Translate>
            </span>
          </dt>
          <dd>{paymentCommunityEntity.description}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.paymentCommunity.active">Active</Translate>
            </span>
          </dt>
          <dd>{paymentCommunityEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.paymentCommunity.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{paymentCommunityEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.paymentCommunity.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{paymentCommunityEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.paymentCommunity.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{paymentCommunityEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.paymentCommunity.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{paymentCommunityEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.paymentCommunity.hospital">Hospital</Translate>
          </dt>
          <dd>{paymentCommunityEntity.hospital ? paymentCommunityEntity.hospital.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.paymentCommunity.institution">Institution</Translate>
          </dt>
          <dd>{paymentCommunityEntity.institution ? paymentCommunityEntity.institution.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/payment-community" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/payment-community/${paymentCommunityEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PaymentCommunityDetail;
